import { render, staticRenderFns } from "./DataclassDisplay.vue?vue&type=template&id=1128d8df&"
import script from "./DataclassDisplay.vue?vue&type=script&lang=js&"
export * from "./DataclassDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports